import type { VehicleEconomy, VehicleEconomyUpsertInput } from '@/types/vehicleEconomy';
import { toDateInputValue } from '@/utils/dateUtils';

export type EconomyFormState = VehicleEconomyUpsertInput & {
  currency_code: string;
  status: string;
};

export const emptyEconomyForm: EconomyFormState = {
  currency_code: 'SEK',
  status: 'ACTIVE',
};

export function formFromEconomy(e: VehicleEconomy): EconomyFormState {
  return {
    currency_code: e.currency_code || 'SEK',
    status: e.status || 'ACTIVE',
    agreement_no: e.agreement_no,
    contract_no: e.contract_no,
    rent_start: toDateInputValue(e.rent_start),
    rent_end: toDateInputValue(e.rent_end),
    term_months: e.term_months,
    leasing_product: e.leasing_product,
    original_base_price: e.original_base_price,
    book_value: e.book_value,
    guaranteed_residual_value: e.guaranteed_residual_value,
    cost_month_leasing: e.cost_month_leasing,
    cost_month_maintenance: e.cost_month_maintenance,
    odometer_start: e.odometer_start,
    allowed_distance: e.allowed_distance,
    cost_per_extra_km: e.cost_per_extra_km,
    leasing_company_id: e.leasing_company_id,
    insurance_start_date: toDateInputValue(e.insurance_start_date),
    insurance_end_date: toDateInputValue(e.insurance_end_date),
    insurance_agreement_no: e.insurance_agreement_no,
    insurance_baseline_monthly: e.insurance_baseline_monthly,
    cost_month_insurance: e.cost_month_insurance,
    cost_month_tax: e.cost_month_tax,
    cost_month_tax_malus: e.cost_month_tax_malus,
    insurance_company_id: e.insurance_company_id,
    residual_value: e.residual_value,
    end_value: e.end_value,
    accumulated_depreciation: e.accumulated_depreciation,
    current_value: e.current_value,
    increased_initial_rent: e.increased_initial_rent,
    payment_type: e.payment_type,
    ownership_type: e.ownership_type,
    ownership_source: e.ownership_source,
    rent_purpose: e.rent_purpose,
    vehicle_supplier_id: e.vehicle_supplier_id,
    disposal_type: e.disposal_type,
    disposal_date: toDateInputValue(e.disposal_date),
    disposal_sale_amount: e.disposal_sale_amount,
    disposal_extra_costs: e.disposal_extra_costs,
    disposal_notes: e.disposal_notes,
    cost_center_id_leasing: e.cost_center_id_leasing,
    cost_center_id_insurance: e.cost_center_id_insurance,
    cost_center_id_tax: e.cost_center_id_tax,
    cost_center_id_tax_malus: e.cost_center_id_tax_malus,
  };
}
